module.exports = __webpack_public_path__ + "static/media/kcs.539aa65c.png";